import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000",
  timeout: 120000,
});

// Wake up backend on app load
setTimeout(() => {
  api.get("/api/health").catch(() => {});
}, 1000);

export const documentsAPI = {
  list: () => api.get("/api/documents"),
  upload: (file) => {
    const form = new FormData();
    form.append("file", file);
    return api.post("/api/documents/upload", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  ingestURL: (url) => api.post("/api/documents/ingest-url", { url }),
  delete: (docId) => api.delete(`/api/documents/${docId}`),
};

export const chatAPI = {
  send: (payload) => api.post("/api/chat", payload),
};

export const compareAPI = {
  compare: (payload) => api.post("/api/compare", payload),
};

export const searchAPI = {
  search: (payload) => api.post("/api/search", payload),
};

export const documentMapAPI = {
  get: () => api.get("/api/document-map"),
};

export const exportAPI = {
  exportPDF: (messages, title) =>
    api.post(
      "/api/export-pdf",
      { messages, title },
      { responseType: "blob" }
    ),
};

export const healthAPI = {
  check: () => api.get("/api/health"),
};

export default api;
